import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import MetaTags from '@/components/MetaTags';
// import PressBanner from '@/components/blocks/PressBanner';
import useMetaTags from '@/hooks/useMetaTags';
import PageTitle from '@/components/PageTitle';
import { useTheme } from '@forma/forma-ui-theme';
import { useContext } from 'react';
import getHeadersFromServer from '@/helpers/getHeadersFromServer';

import mockApi from '@/api/mockApi';

import styles from './Press.module.css';

export const getServerSideProps = async ({ req, res, params }) => {
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=14400, stale-while-revalidate=10'
  );
  const mainData = await mockApi.getMainData(params.locale);
  const pageData = await mockApi.getPageData(params.locale, 'press');
  const headersParse = await getHeadersFromServer(req);
  return {
    props: {
      initialState: {
        main: mainData,
      },
      press: pageData,
      headersParse,
      ...(await serverSideTranslations(params.locale, ['common', 'uikit'])),
    },
  };
};

const ContentPage = ({ press }) => {
  const { t } = useTranslation();
  const { description, contacts } = press;

  const metaData = {
    title: t('meta_titles.press'),
    description: t('meta_descriptions.press'),
    keywords: t('main_keywords'),
  };
  const { lang } = useTheme();
  useMetaTags({ lang, ...metaData });

  return (
    <div>
      <Head>
        <title>{metaData.title}</title>
        <MetaTags {...metaData} />
      </Head>

      <div className="container">
        <PageTitle
          breadcrumbs={[{ name: t('for_press') }]}
          title={t('for_press')}
        />

        <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
        <div className={styles.contacts} dangerouslySetInnerHTML={{ __html: contacts }} />

        {/* <PressBanner {...guide_banner} /> */}
      </div>
    </div>
  );
};

export default ContentPage;
